import type { AnyAction } from 'redux';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { SelectedCheckboxFilter } from '../../components/selectedCheckboxFilter/SelectedCheckboxFilter';
import { mapFavoriteFolders } from '../favoriteFoldersFilter/FavoriteFoldersFilter';
import { useFavoriteHotelsAPI } from '@/hooks/favoriteHotelsAPI';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';

interface Props {
    openFilters: () => void;
}

export const SelectedFavoriteFoldersFilter = ({ openFilters }: Props) => {
    const favoriteHotels = useFavoriteHotelsAPI();
    const dispatch = useAppDispatch();
    const checkboxValues = useAppSelector((state) => state.filters.favoriteHotels);

    return (
        <SelectedCheckboxFilter
            id="FavoriteFoldersFilter"
            checkboxValues={checkboxValues}
            facetList={mapFavoriteFolders(favoriteHotels?.folders)}
            checkBoxClick={(value) => dispatch(actions.filterFavoriteHotels(value))}
            triggerFetch={() => dispatch(fetchHotels() as unknown as AnyAction)}
            openFilters={openFilters}
        />
    );
};
